/** Registered event card shape aligned with attendee-home GraphQL `EventCard` / slice usage. */
export type AttendeeRegisteredEvent = {
  id: string;
  name: string;
  timeStart: string;
  timeEnd: string;
  slug: string;
  registrationPageUrl: string;
  hostName: string;
  imageSmallUrl: string | null;
  minTicketPrice: {
    amount: unknown;
    currencyCode: string;
  } | null;
  maxTicketPrice: {
    amount: unknown;
    currencyCode: string;
  } | null;
};

export type AttendeeHomeListState = {
  items: AttendeeRegisteredEvent[];
  pageInfo: {
    hasNextPage: boolean;
    endCursor: string | null;
  };
  status: 'idle' | 'processing' | 'success' | 'failed';
  error: { message: string } | null;
};

export type AttendeeHomeState = {
  upcoming: AttendeeHomeListState;
  past: AttendeeHomeListState;
};

const emptyListState: AttendeeHomeListState = {
  items: [],
  pageInfo: { hasNextPage: false, endCursor: null },
  status: 'idle',
  error: null,
};

export const defaultAttendeeHomeState: AttendeeHomeState = {
  upcoming: { ...emptyListState },
  past: { ...emptyListState },
};
